module.exports = __webpack_public_path__ + "static/media/haha2.b9cfa53d.gif";